module.exports = __webpack_public_path__ + "static/eula-selected-d14d961c9b1af6b5ebf232d941df440e.png";